module.exports = __webpack_public_path__ + "static/media/pathi.b6576a38.png";